import React from 'react';

export const PrivacyPolicyPt: React.FC = () => (
  <>
    <section>
      <h2>1. Responsável pelo tratamento</h2>
      <p>
        <strong>Leonardo Ferreira</strong>, na qualidade de pessoa singular que explora a plataforma
        Roadbase
      </p>
      <p>NIF 305516760</p>
      <p>Praça Nove de Abril, 123, 4200-422 Porto, Portugal</p>
      <p>
        Email: <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>
      </p>
      <p>
        Para qualquer questão relativa a dados pessoais, incluindo o exercício dos seus direitos,
        contacte-nos através do email acima.
      </p>
    </section>

    <section>
      <h2>2. Que dados recolhemos</h2>
      <p>
        <strong>Dados de conta.</strong> Nome, endereço de email, nome da empresa e, quando
        fornecido, telefone. A palavra-passe é guardada apenas sob a forma de hash criptográfico —
        não temos acesso à palavra-passe em texto legível.
      </p>
      <p>
        <strong>Dados dos pedidos de cotação.</strong> Origem e destino (cidade, país, código
        postal), descrição da carga, dimensões, peso, tipo de equipamento pretendido, janelas de
        carga e descarga, observações, e quaisquer ficheiros ou imagens que anexe.
      </p>
      <p>
        <strong>Dados técnicos.</strong> Endereço IP, data e hora de acesso, tipo de navegador e
        registos de utilização, recolhidos automaticamente pelos nossos servidores.
      </p>
      <p>
        <strong>Comunicações.</strong> O conteúdo das mensagens que nos envie por email ou através
        da plataforma.
      </p>
      <p>
        Não recolhemos categorias especiais de dados pessoais (saúde, convicções, biometria) nem
        dados de menores. A plataforma destina-se exclusivamente a utilizadores profissionais.
      </p>
    </section>

    <section>
      <h2>3. Para que usamos os dados e com que fundamento</h2>
      <table>
        <thead>
          <tr>
            <th>Finalidade</th>
            <th>Fundamento legal</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Criar e gerir a sua conta</td>
            <td>Execução do contrato (art. 6.º, n.º 1, al. b) do RGPD)</td>
          </tr>
          <tr>
            <td>Processar pedidos de cotação e contactar transportadoras em seu nome</td>
            <td>Execução do contrato ou diligências pré-contratuais</td>
          </tr>
          <tr>
            <td>
              Enviar comunicações operacionais (confirmação de pedido, cotações recebidas,
              alterações de estado)
            </td>
            <td>Execução do contrato</td>
          </tr>
          <tr>
            <td>Segurança da plataforma, prevenção de abuso, registos de acesso</td>
            <td>Interesse legítimo (art. 6.º, n.º 1, al. f)</td>
          </tr>
          <tr>
            <td>Melhorar o serviço com base na utilização agregada</td>
            <td>Interesse legítimo</td>
          </tr>
          <tr>
            <td>Comunicações comerciais dirigidas a empresas</td>
            <td>Interesse legítimo, com direito de oposição a qualquer momento</td>
          </tr>
          <tr>
            <td>Cumprimento de obrigações legais e contabilísticas</td>
            <td>Obrigação jurídica (art. 6.º, n.º 1, al. c)</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section>
      <h2>4. Com quem partilhamos os dados</h2>
      <p>
        <strong>Transportadoras.</strong> Para obter cotações, transmitimos às transportadoras as{' '}
        <strong>características da carga e da rota</strong> — origem, destino, dimensões, peso,
        equipamento e datas. <strong>Não transmitimos a sua identidade nem os seus dados de contacto</strong>,
        salvo se nos autorizar expressamente. A negociação e o contrato de transporte, se avançarem,
        passam a ser diretamente entre si e a transportadora, momento a partir do qual a partilha de
        dados entre ambos deixa de estar sob o nosso controlo.
      </p>
      <p>
        <strong>Subcontratantes.</strong> Recorremos aos seguintes prestadores, que tratam dados por
        nossa conta e sob instruções escritas:
      </p>
      <table>
        <thead>
          <tr>
            <th>Prestador</th>
            <th>Função</th>
            <th>Localização</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Hostinger</td>
            <td>Alojamento do servidor onde correm a aplicação, a base de dados e os ficheiros</td>
            <td>Alemanha (UE)</td>
          </tr>
          <tr>
            <td>Resend</td>
            <td>Envio de email transacional</td>
            <td>Irlanda (UE)</td>
          </tr>
          <tr>
            <td>Google (Drive)</td>
            <td>Repositório das cópias de segurança encriptadas</td>
            <td>EUA</td>
          </tr>
          <tr>
            <td>HubSpot</td>
            <td>Gestão de contactos comerciais e prospeção (não trata dados da plataforma)</td>
            <td>EUA</td>
          </tr>
        </tbody>
      </table>
      <p>
        A base de dados e os ficheiros que nos envia estão alojados no nosso próprio servidor, não
        em serviços de terceiros. Os ficheiros são guardados em armazenamento separado por tipo:
        anexos enviados por clientes, PDFs de propostas e materiais internos ficam em áreas
        distintas.
      </p>
      <p>
        <strong>Autoridades.</strong> Quando legalmente obrigados a fazê-lo.
      </p>
      <p>
        Não vendemos dados pessoais nem os cedemos a terceiros para fins publicitários.
      </p>
    </section>

    <section>
      <h2>5. Transferências para fora do Espaço Económico Europeu</h2>
      <p>
        O servidor, a base de dados, os ficheiros e o envio de email estão integralmente dentro da
        União Europeia. Saem da UE apenas as cópias de segurança, alojadas no Google Drive, e os
        contactos comerciais geridos no HubSpot. Essas transferências assentam nas Cláusulas
        Contratuais-Tipo aprovadas pela Comissão Europeia e, quando aplicável, na certificação do
        prestador ao abrigo do EU-U.S. Data Privacy Framework.
      </p>
      <p>
        As cópias de segurança são encriptadas no nosso servidor <strong>antes</strong> de serem
        transferidas, e só podem ser lidas com uma chave que permanece sob o nosso controlo. O
        prestador que as aloja não tem acesso ao seu conteúdo.
      </p>
    </section>

    <section>
      <h2>6. Durante quanto tempo guardamos os dados</h2>
      <p>A conservação tem duas camadas independentes: o sistema ativo e as cópias de segurança.</p>

      <h3>No sistema ativo</h3>
      <table>
        <thead>
          <tr>
            <th>Dados</th>
            <th>Conservação</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ficheiros e imagens que anexa a um pedido</td>
            <td>Eliminados cerca de 3 meses após a criação do pedido</td>
          </tr>
          <tr>
            <td>PDFs de propostas gerados pela Roadbase</td>
            <td>Eliminados quando a proposta caduca; um PDF regenerado caduca após 3 dias</td>
          </tr>
          <tr>
            <td>Conta e perfil</td>
            <td>Enquanto a conta estiver ativa</td>
          </tr>
          <tr>
            <td>Pedidos de cotação, propostas e registos de utilização</td>
            <td>
              Enquanto forem necessários para as finalidades desta política — designadamente manter
              o seu historial, responder a questões sobre pedidos anteriores e defender direitos em
              caso de litígio
            </td>
          </tr>
          <tr>
            <td>Documentos com relevância fiscal</td>
            <td>10 anos, por imposição legal</td>
          </tr>
        </tbody>
      </table>
      <p>
        Pode pedir a eliminação dos seus dados a qualquer momento através de{' '}
        <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>. Procedemos à remoção do sistema
        ativo na sequência do pedido.
      </p>

      <h3>Nas cópias de segurança</h3>
      <p>
        As cópias de segurança são snapshots encriptados, guardados exclusivamente para recuperação
        em caso de falha do sistema. Não são consultados no funcionamento corrente nem usados para
        qualquer outra finalidade.
      </p>
      <ul>
        <li>
          A cópia <strong>diária</strong> inclui a base de dados e a configuração do servidor. Não
          inclui os ficheiros que nos envia.
        </li>
        <li>
          A cópia <strong>semanal</strong> inclui tudo o que está na diária e ainda os ficheiros, os
          PDFs de propostas e os materiais internos. É o ponto de recuperação em caso de falha total
          do servidor.
        </li>
      </ul>
      <p>
        A rotação é automática e mantém, por cada grupo de cópias, até 7 snapshots diários, 5
        semanais e 12 mensais.
      </p>
      <p>
        Daqui resulta uma consequência que importa conhecer:{' '}
        <strong>
          dados eliminados do sistema ativo podem permanecer em snapshots históricos encriptados por
          até cerca de 12 meses
        </strong>
        , findo o que são removidos automaticamente pela rotação. Enquanto isso, ficam apenas em
        cópias encriptadas e não voltam a ser tratados. Caso uma cópia venha alguma vez a ser
        restaurada, os pedidos de eliminação entretanto recebidos são novamente aplicados.
      </p>
      <p>
        O procedimento de recuperação existente destina-se a repor o sistema completo após uma falha
        grave. Não dispomos de um mecanismo para extrair ou apagar de forma seletiva um único
        ficheiro ou registo dentro de um snapshot já criado.
      </p>
    </section>

    <section>
      <h2>7. Os seus direitos</h2>
      <p>
        Assiste-lhe o direito de aceder aos seus dados, de os retificar, de solicitar a sua
        eliminação, de limitar ou de se opor ao tratamento, e de os receber num formato estruturado
        e de uso corrente (portabilidade). Pode ainda retirar o consentimento, quando o tratamento
        nele assente, sem que isso afete a licitude do tratamento anterior.
      </p>
      <p>
        Para exercer qualquer destes direitos, escreva para{' '}
        <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>. Respondemos no prazo de um mês.
      </p>
      <p>
        Se considerar que os seus dados não estão a ser tratados corretamente, pode apresentar
        reclamação à <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong> —{' '}
        <a href="https://www.cnpd.pt">www.cnpd.pt</a>.
      </p>
    </section>

    <section>
      <h2>8. Segurança</h2>
      <p>
        A plataforma é servida exclusivamente por ligação encriptada (HTTPS). As palavras-passe são
        guardadas com algoritmo de hash, não em texto legível. As cópias de segurança são
        encriptadas antes de saírem do servidor. O acesso administrativo está limitado às pessoas
        estritamente necessárias à operação do serviço.
      </p>
      <p>
        Nenhum sistema é totalmente imune. Se ocorrer uma violação de dados suscetível de implicar
        risco elevado para os seus direitos, notificá-lo-emos a si e à CNPD nos termos legalmente
        exigidos.
      </p>
    </section>

    <section>
      <h2>9. Cookies</h2>
      <p>
        Utilizamos apenas cookies estritamente necessários ao funcionamento da plataforma —
        designadamente para manter a sua sessão iniciada. Não utilizamos cookies de publicidade nem
        de análise de comportamento, pelo que não é apresentado pedido de consentimento.
      </p>
    </section>

    <section>
      <h2>10. Alterações a esta política</h2>
      <p>
        Podemos atualizar esta política. A data da última atualização consta no topo. Alterações com
        impacto material são comunicadas por email aos utilizadores registados com pelo menos 15
        dias de antecedência.
      </p>
    </section>

    <section>
      <h2>11. Contacto</h2>
      <p>
        <strong>Leonardo Ferreira</strong> — <a href="mailto:info@roadbase.eu">info@roadbase.eu</a>
      </p>
    </section>
  </>
);
